import dJSON from 'dirty-json';
import Splide from '@splidejs/splide';
import { setupSplide } from '../../../js/global';

/**
 * Module Init
 */
(() => {
  const moduleSelector = '.testimonials-widget .splide';
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    const sliderList = query.querySelector('.splide__list');
    try {
      sliderList.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(sliderList.data);

      data.forEach((item) => {
        query.querySelector('.splide__list').insertAdjacentHTML('beforeend', /* html */ `
          <div class="splide__slide">
            <div class="content-wrapper">
              <div class="text">"${item.text}"</div>
              <p class="name">${item.name}</p>
            </div>
          </div>
        `);
      });

      const slider = new Splide(query, {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        pagination: true,
        arrows: false,
        autoplay: true,
        interval: 10000,
      });
      setupSplide(slider);
      slider.mount();
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

/**
 * Add class "container" to the slider pagination
 */
(() => {
  const sliderPagination = document.querySelector('.testimonials-widget .splide__pagination');
  if (sliderPagination) {
    sliderPagination.classList.add('container');
  }
})();
